// extracted by mini-css-extract-plugin
export var button = "_kj-0";
export var donut = "_kj-1";
export var donutFill = "_kj-3";
export var donutTrack = "_kj-2";